import React, { useState } from 'react';
import SidebarNew from '../SidebarNew/SidebarNew'
import { useForm } from 'react-hook-form';
import axios from 'axios';

const CreateUpcomingEvent = () => {
    const [imageURL, setImageURL] = useState(null);
    const [imageOnProcess, setImageOnProcess] = useState(false);
    const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();

    // format date
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = new Date(dateString).toLocaleDateString(undefined, options);
        return formattedDate;
    };

    const handleImageUpload = (event) => {
        const imageData = new FormData();
        imageData.set('key', '2dad6d7bf6cef1ec0ba10a9e39066744');
        imageData.append('image', event.target.files[0]);

        setImageOnProcess(true);

        axios.post('https://api.imgbb.com/1/upload', imageData)
            .then(res => {
                console.log(res.data.data.display_url);
                setImageURL(res.data.data.display_url);
                setImageOnProcess(false);
            })
            .catch(err => {
                console.log(err);
            })
        console.log('image clicked')
    }

    const onSubmit = data => {
        const formattedDate = formatDate(data.date)
        const newEventData = {
            ...data,
            date: formattedDate,
            img: imageURL
        }
        fetch(`https://al-maghrib-server.vercel.app/upcomingEvent/createUpcomingEvent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(newEventData)
        })
            .then(data => {
                if (data.ok) {
                    alert("Upcoming Event created successfully.")
                } else { alert("Sorry. Upcoming Event cannot created.") }

            })

        reset()

    }
    return (
        <div style={{ display: 'flex' }}>
            <SidebarNew />
            <div className='container'>
                <h1 className='text-violet-900	text-6xl mb-5'>Create An Upcoming Event</h1>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <label className="block">
                        <span className="block text-sm font-medium text-slate-700">Date of upcoming event</span>
                        <input type="date" name="date" {...register("date", { required: true })} className="block w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-sm shadow-sm placeholder-slate-400" />
                        {errors.date && <span>This field is required</span>}
                    </label>

                    <label class="block">
                        <span className="mt-3 block text-sm font-medium text-slate-700">Headline</span>
                        <textarea type="text" name="headline" {...register("headline", { required: true })} rows="4" cols="50" className="block w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-sm shadow-sm placeholder-slate-400" />
                        {/* errors will return when field validation fails  */}
                        {errors.headline && <span>This field is required</span>}
                    </label>

                    <label class="block">
                        <span class="mt-3 block text-sm font-medium text-slate-700">Event Image (optional)</span>
                        <div class="shrink-0">
                            {imageOnProcess && <p className='text-red-800 my-5'>Please wait ...</p>}
                            <img class="h-auto w-auto object-contain" src={imageURL} alt="" />
                        </div>
                        <input name="file" type="file" onChange={handleImageUpload} class="block w-full text-sm text-slate-500
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:bg-violet-50 file:text-violet-700
                            hover:file:bg-violet-100
                        "/>
                    </label>

                    <br /><br />
                    <input type="submit" disabled={imageOnProcess} className='mt-3 mb-3 btn btn-success text-dark' />
                </form>
            </div>
        </div>
    );
};

export default CreateUpcomingEvent;